/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Ask an Expert button — opens the Shopify Inbox live chat widget.
 * Inbox renders as the <shopify-chat> custom element with a shadow DOM; we find its
 * internal "Open chat" toggle button and simulate a click on it. If Inbox isn't loaded yet
 * or isn't installed, we fail quietly rather than throwing an error on the page.
 */
function handleAskAnExpertClick(event) {
  if (event) {
    event.preventDefault();
  }

  var chatElement = document.querySelector('shopify-chat');
  var toggleButton = chatElement && chatElement.shadowRoot && chatElement.shadowRoot.querySelector('button.activator');

  if (toggleButton) {
    toggleButton.click();
  } else {
    console.warn('Ask an Expert: Shopify Inbox chat widget was not found on this page.');
  }
}
